export { DMS_MODULE } from '../constants';
export const NAME = 'WmsServiceAdvisor';
export const API_NAME = 'WmsServiceAdvisor';
export const CRUMB_LABEL_KEY = 'WmsServiceAdvisor';
